var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.444 18.3333L17.0551 14.9444C17.9718 13.6944 18.5273 12.1667 18.5273 10.5C18.5273 6.36111 15.1662 3 11.0273 3C6.88845 3 3.52734 6.36111 3.52734 10.5C3.52734 14.6389 6.88845 18 11.0273 18C12.694 18 14.2218 17.4444 15.4718 16.5278L18.8607 19.9167C19.0829 20.1389 19.3607 20.25 19.6662 20.25C19.944 20.25 20.2496 20.1389 20.4718 19.9167C20.8607 19.5 20.8607 18.7778 20.444 18.3333ZM10.9996 15.75C8.11068 15.75 5.74957 13.3889 5.74957 10.5C5.74957 7.61111 8.11068 5.25 10.9996 5.25C13.8885 5.25 16.2496 7.61111 16.2496 10.5C16.2496 13.3889 13.9162 15.75 10.9996 15.75Z",
    fill: "#141938"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.3a751194f4cfe38969a7c10c5e1e4007.svg";
export { ForwardRef as ReactComponent };